{
  "dismiss": "무시"
}